// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { SimpleRole, ISimpleRole } from "./SimpleRole.gen";

export interface ISimpleUser {
	id: string | undefined;

	email: string | undefined;

	firstName: string | undefined;

	lastName: string | undefined;

	userRoles: ISimpleRole[] | undefined;

	isSuperAdmin: boolean;

	$type?: string | undefined;
}
export class SimpleUser {
	constructor(data?: ISimpleUser) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.userRoles = data.userRoles ? data.userRoles.map((u: any) => new SimpleRole(u)) : [];
	}

	id: string | undefined;

	email: string | undefined;

	firstName: string | undefined;

	lastName: string | undefined;

	userRoles: SimpleRole[] | undefined = [];

	isSuperAdmin: boolean = false;

	static $type: string = "CoreApi.Models.SimpleUser, ";
	$type?: string | undefined = SimpleUser.$type;
}

